import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/css/index.css";
import {
  GIFT_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_ID,
  PDF_COURSE_PURCHASE_SUBSCRIPTION_PLAN_ID,
  PREMIUM_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_ID,
  PROFILE_REPORT_PURCHASE_SUBSCRIPTION_PLAN_ID,
} from "./utils/constants";
import * as Sentry from "@sentry/react";
import packageJson from "../package.json";
import {
  browserSessionIntegration,
  browserTracingIntegration,
} from "@sentry/react";

console.log(packageJson.version, process.env.REACT_APP_SENTRY_ENVIRONMENT);

declare global {
  interface Window {
    subtrack_url: string;
    pdf_course_id: string;
    profile_report_id: string;
    premium_id: string;
    gift_id: string;
  }
}

if (process.env.NODE_ENV === "production") {
  const APP_RELEASE_VERSION = `${packageJson.name}@${packageJson.version}`;

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    tracesSampleRate: 0.5,
    sendDefaultPii: true,
    integrations: [browserTracingIntegration(), browserSessionIntegration()],
    release: APP_RELEASE_VERSION,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "unknown",
    // Включаем отладочную информацию для sourcemaps
    debug: false,
    beforeSend(event: any, hint: any) {
      // Добавляем контекстную информацию для лучшей отладки
      if (event.exception) {
        const error = hint.originalException;
        console.error("Sentry capturing error:", error);

        if (
          error &&
          error.message &&
          error.message.includes(
            "undefined is not an object (evaluating 'window.webkit.messageHandlers"
          )
        ) {
          return null;
        }
        // Добавляем информацию о релизе в контекст
        event.contexts = event.contexts || {};
        event.contexts.app = {
          ...event.contexts.app,
          version: packageJson.version,
          build_time: new Date().toISOString(),
        };
      }
      return event;
    },
  });

  // Запускаем сессию для health tracking
  Sentry.captureSession();
}
// set default plan ids
window.subtrack_url = process.env.REACT_APP_SUBTRACK_URL ?? "";
window.pdf_course_id = PDF_COURSE_PURCHASE_SUBSCRIPTION_PLAN_ID;
window.profile_report_id = PROFILE_REPORT_PURCHASE_SUBSCRIPTION_PLAN_ID;
window.premium_id = PREMIUM_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_ID;
window.gift_id = GIFT_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_ID;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
    <App />
  </Sentry.ErrorBoundary>
);
